import "../models/question.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Collections ??= {};

AssessmentBuilder.Collections.Questions = class Questions extends Backbone.Collection {};
AssessmentBuilder.Collections.Questions.prototype.model = AssessmentBuilder.Models.Question;
AssessmentBuilder.Collections.Questions.prototype.comparator = "position";
